import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useCurrency } from '../context/CurrencyContext';

function FeaturedProductsManage() {
    const [products, setProducts] = useState([]);
    const [featuredIds, setFeaturedIds] = useState([]);
    const currencySymbol = useCurrency();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchProducts();
        fetchFeatured();
    }, []);

    const fetchProducts = async () => {
        try {
            const tg = window.Telegram.WebApp;
            const res = await axios.get('/api/merchant/products', {
                headers: { 'x-telegram-init-data': tg.initData }
            });
            setProducts(res.data);
        } catch (error) {
            console.error('获取商品失败', error);
        }
    };

    const fetchFeatured = async () => {
        try {
            const tg = window.Telegram.WebApp;
            const res = await axios.get('/api/merchant/featured-products', {
                headers: { 'x-telegram-init-data': tg.initData }
            });
            setFeaturedIds(res.data.data.map(item => item.product_id));
        } catch (error) {
            console.error('获取置顶商品失败', error);
        }
    };

    const toggleFeatured = async (productId) => {
        let newFeatured = [...featuredIds];
        
        if (newFeatured.includes(productId)) {
            newFeatured = newFeatured.filter(id => id !== productId);
        } else {
            if (newFeatured.length >= 3) {
                alert('最多只能选择3个置顶商品');
                return;
            }
            newFeatured.push(productId);
        }
        
        setLoading(true);
        try {
            const tg = window.Telegram.WebApp;
            await axios.put('/api/merchant/featured-products', 
                { productIds: newFeatured },
                { headers: { 'x-telegram-init-data': tg.initData } }
            );
            setFeaturedIds(newFeatured);
            alert('置顶商品更新成功');
        } catch (error) {
            alert('更新失败：' + (error.response?.data?.message || error.message));
        } finally {
            setLoading(false);
        }
    };

    const getProductImage = (product) => {
        if (product.images && product.images.length > 0) {
            return product.images[0];
        }
        return 'https://via.placeholder.com/60';
    };

    return (
        <div style={{ padding: '20px' }}>
            <h2>置顶商品管理</h2>
            <p style={{ color: '#666', marginBottom: '20px' }}>
                选择最多3个商品置顶，置顶的商品会显示在顾客点餐页面的顶部
            </p>
            
            <div style={{ background: '#f5f5f5', padding: '20px', borderRadius: '8px' }}>
                <h3>选择置顶商品</h3>
                <p style={{ fontSize: '14px', color: '#ff6b6b', marginBottom: '15px' }}>
                    已选择 {featuredIds.length}/3 个置顶商品
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {products.length === 0 ? (
                        <p style={{ color: '#999' }}>暂无商品，请先在商品管理中添加</p>
                    ) : (
                        products.map(product => (
                            <div 
                                key={product.id} 
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    padding: '12px',
                                    background: 'white',
                                    borderRadius: '8px',
                                    border: featuredIds.includes(product.id) ? '1px solid #ff6b6b' : '1px solid #eee'
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <img 
                                        src={getProductImage(product)} 
                                        alt={product.name}
                                        style={{ width: '50px', height: '50px', borderRadius: '6px', objectFit: 'cover' }}
                                    />
                                    <div>
                                        <div style={{ fontWeight: '500' }}>{product.name}</div>
                                        <div style={{ fontSize: '14px', color: '#ff6b6b' }}>
                                            {currencySymbol}{product.price}
                                        </div>
                                    </div>
                                </div>
                                <button
                                    onClick={() => toggleFeatured(product.id)}
                                    disabled={loading}
                                    style={{
                                        padding: '6px 16px',
                                        background: featuredIds.includes(product.id) ? '#ff6b6b' : '#f0f0f0',
                                        color: featuredIds.includes(product.id) ? 'white' : '#666',
                                        border: 'none',
                                        borderRadius: '20px',
                                        cursor: 'pointer',
                                        fontSize: '13px'
                                    }}
                                >
                                    {featuredIds.includes(product.id) ? '⭐ 已置顶' : '☆ 设为置顶'}
                                </button>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}

export default FeaturedProductsManage;